import { Loader2 } from "lucide-react";

const FullScreenLoader = () => {
  return (
    <div className="flex h-screen items-center justify-center">
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
    </div>
  );
};

export default FullScreenLoader;
